<template>
    <div
        class="model-search"
        @click="focusInput"
    >
        <input
            v-model="localValue"
            ref="input"
            type="text"
            :placeholder="$t('model.nlu-model.header.search.typeToSearch')"
        />
        <or-icon
            class="material-icons"
            :icon="icon"
            @click.stop.prevent="iconHandler"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },

  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.debouncedInput(value)
      }
    },

    icon () {
      return _.isEmpty(this.localValue) ? 'search' : 'close'
    }
  },

  methods: {
    ...mapActions('knowledgebase/notifications', ['addInfo']),

    debouncedInput: _.debounce(function (value) {
      value.length === 1
        ? this.addInfo({ titleLabel: 'model.nlu-model.header.search.errors.minLength' })
        : this.$emit('input', value)
    }, 1000),

    focusInput () {
      this.$refs.input.focus()
    },

    iconHandler () {
      this.localValue !== '' ? this.$emit('input', '') : this.focusInput()
    }
  }
}
</script>

<style lang="scss" scoped>
    .model-search {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 30px;
        width: 190px;
        padding: 8px 10px;
        background: $or-white;
        border: 1px solid $or-grey;
        border-radius: 4px;
        cursor: pointer;

        &:focus-within {
            border: 1px solid $or-blue;

            .material-icons {
                color: $or-blue;
            }
        }

        input {
            width: 100%;
            font-size: 14px;
            border: none;
            outline: none;
            color: $or-black-blue;
            background: transparent;

            &::placeholder {
                color: $or-grey;
            }
        }

        .material-icons {
            font-size: 18px;
            color: $or-grey;
        }
    }
</style>
